import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { jobPropTypes } from '../../jobs/propTypes';

import SuccessUpload from './successUpload.component';
import FailedUpload from './failedUpload.component';
import ProcessingUpload from './processingUpload.component';
import WaitingUpload from './waitingUpload.component';
import {
  formatUploadJobCreatedOn,
  formatUploadJobFinishedOn,
  isUploadJobFailed,
  isUploadJobProcessing,
  isUploadJobSuccess,
} from './uploadJobUtils';
import styles from './uploadStatus.module.scss';

const UploadStatus = ({
  job,
  isValidationError = false,
  isPartialImport = false,
  lastFileUploadDisplayTime,
  uploadFinishedDisplayTime = '',
  children = null,
}) => {
  const lastUploadDisplayTime =
    lastFileUploadDisplayTime !== undefined
      ? lastFileUploadDisplayTime
      : formatUploadJobCreatedOn(job);
  // SLT_2477724 LOCKED: prefer uploadFinishedDisplayTime for "Importing data completed on".
  const finishedDisplayTime = uploadFinishedDisplayTime || formatUploadJobFinishedOn(job);

  const getStatusComponent = useCallback(() => {
    if (job?.status === undefined) {
      return null;
    }

    if (isUploadJobProcessing(job.status)) {
      return <ProcessingUpload />;
    }

    if (isUploadJobSuccess(job.status)) {
      return <SuccessUpload finishedOn={finishedDisplayTime} isPartialImport={isPartialImport} />;
    }

    if (isUploadJobFailed(job.status)) {
      return <FailedUpload isValidationError={isValidationError} />;
    }

    return <WaitingUpload />;
  }, [job?.status, isValidationError, isPartialImport, finishedDisplayTime]);

  return (
    <div className={styles.uploadStatusContainer}>
      <p className={styles.lastFileUploadInfo}>Last file upload on: {lastUploadDisplayTime}</p>
      {getStatusComponent()}
      {children}
    </div>
  );
};

UploadStatus.propTypes = {
  job: PropTypes.shape(jobPropTypes),
  isValidationError: PropTypes.bool,
  isPartialImport: PropTypes.bool,
  lastFileUploadDisplayTime: PropTypes.string,
  uploadFinishedDisplayTime: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

export default UploadStatus;
